import apiClient from "@/libs/axios";
import store from "@/state/store";
import router from "@/router";

export const state = {
    data: [],
    vendorStats: [],
    details: null,
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setVendorStats: (state, data) => {
        state.vendorStats = data.result;
    },

    setDetails: (state, data) => {
        state.details = data.result;
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, vendor: {...item.vendor, status: data.status, is_active: data.vendor.is_active}} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async get({ commit }, data) {

        const filters = window.mapFilterData(data);

        await apiClient
            .get(`api/v1/users/vendors${filters}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async details({ commit }, data) {

        await apiClient
            .get(`api/v1/vendors/show?id=${data.id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setDetails', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async update({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .post(`api/v1/vendors/update`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(response => {
                commit('app/loadingFinish', null, {root: true});
                if (response.status === 200) {
                    commit('setDetails', response.data)
                }
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            });
    },
    async toggle({ commit }, data) {
        await apiClient
            .post(`api/v1/users/vendors/toggle`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data.result);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async approve({ commit }, data) {
        await apiClient
            .patch(`api/v1/users/vendors/approve`, data)
            .then(response => {
                console.log(response)
                if (response.status === 201) {
                    commit('updateData', response.data.result);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async reject({ commit }, data) {
        await apiClient
            .patch(`api/v1/users/vendors/reject`, data)
            .then(response => {
                console.log(response)
                if (response.status === 201) {
                    commit('updateData', response.data.result);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async create({ commit }, data) {
        console.log(data);
        data = { vendor_id: store.state.profile.profile.basic.vendor.id, ...data };
        console.log(data)
        await apiClient
            .post(`api/v1/users/vendors/create`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(response => {
                console.log(response.data)
                if (response.status === 201) {
                    commit('updateData', response.data);
                    router.push({ name: "my-services" })
                }
            })
            .catch(error => {
                // this.toast.add({ severity: "error", summary: "Success", detail: error, life: 3000 }); // not working
                throw error;
            },);

    },

    async getMyServices({ commit }, data) {

        const filters = window.mapFilterData(data);

        await apiClient
            .get(`api/v1/users/vendors/my-services${filters}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },

    async getStats({ commit }, data) {
        console.log("GET STATS")
        console.log(data)
        await apiClient
                   // api/v1/users/vendors/stats?id=123
            .get(`api/v1/users/vendors/stats?id=${data.id}`)
            .then(response => {
                if (response.status === 200) {
                console.log(response.data)
                    commit('setVendorStats', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getDetails(state) {
        return state.details;
    },
    getTotal(state) {
        return state.total;
    },
    getVendorStats(state) {
        return state.vendorStats
    },
};
